<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps({
  show: Boolean
});
</script>
<template>
    <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            Please wait
          </div>
          </div>
      </div>
    </div>
  </Transition>
</template>
<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    font-family:'Roboto', sans-serif;
    font-size: larger;
  }
  
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  
  .modal-container {
    max-width: 12rem;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.6rem rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    color: #131E29;
  }
  .modal-body{
      flex-direction: column !important;
      max-height: 80vh;
      overflow: auto;
      padding-top: 1rem;
      padding-bottom: 1rem;
      text-align: left;
      font-family: Roboto;
      font-weight: 700;
      font-size: 1.5rem;
      justify-content: center;
      align-content: center;
      text-align: center;
  }
</style>